import __var_0__ from './ctor.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Hypergeometric distribution constructor.
*
* @module @stdlib/stats/base/dists/hypergeometric/ctor
*
* @example
* var Hypergeometric = require( '@stdlib/stats/base/dists/hypergeometric/ctor' );
*
* var hypergeometric = new Hypergeometric( 40, 10, 8 );
*
* var y = hypergeometric.cdf( 2.8 );
* // returns ~0.688
*
* var mode = hypergeometric.mode;
* // returns 2.0
*/

// MODULES //
var ctor = __var_0__;


// EXPORTS //
export default ctor;
